// No new backend flags can be provisioned: 'Voice Agent Access' reuses EVENTS_SELF, taken from 'Direct marketing'
const consentFlags = {
    AI_ASSISTANT: 'EVENTS_SELF',
};

export default consentFlags;
